import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=2002df1f"
import script from "./InvoicesTable.vue?vue&type=script&lang=ts"
export * from "./InvoicesTable.vue?vue&type=script&lang=ts"
import style0 from "./InvoicesTable.vue?vue&type=style&index=0&id=2002df1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports